import {
  Autocomplete,
  AutocompleteOption,
  createFilterOptions,
  FormControl,
  FormHelperText,
  FormLabel,
  Typography,
} from "@mui/joy";
import { ApiSponsor } from "griptonite-api-client";
import { useController, useFormContext } from "react-hook-form";

import { useSponsorsListQuery } from "@/hooks/competitions";
import getThumbnailUrl from "@/utils/getThumbnailUrl";
const filter = createFilterOptions<ApiSponsor>();

export default function SponsorSelectInput({ name, label }: { name: string; label?: string }) {
  const { control } = useFormContext<Record<string, string[]>>();
  const { field, fieldState } = useController({
    name,
    control,
  });

  const { data: sponsorsList } = useSponsorsListQuery();

  return (
    <FormControl error={Boolean(fieldState.error)}>
      {label && <FormLabel>{label}</FormLabel>}
      <Autocomplete
        openOnFocus
        multiple
        options={sponsorsList || []}
        getOptionLabel={(option) => option.name}
        value={sponsorsList?.filter((x) => field.value.includes(x.uuid))}
        filterOptions={(options, params) => {
          const filtered = filter(options, params);

          const { inputValue } = params;
          // Suggest the creation of a new value
          const isExisting = options.some((option) => inputValue === option.name);
          if (!isExisting) {
            filtered.push({
              uuid: "",
              name: `Message WhatsApp or email support@griptonite.io to add a new sponsor`,
              image: {},
              url: "",
            } as ApiSponsor);
          }

          return filtered;
        }}
        onChange={(_, value) => {
          field.onChange(value.map((sponsor) => sponsor.uuid));
        }}
        onBlur={field.onBlur}
        renderOption={(props, option) => (
          <AutocompleteOption {...props} sx={!option.uuid ? { pointerEvents: "none" } : {}}>
            {option.image.url ? (
              <img
                src={getThumbnailUrl(option.image.url, { mode: "resize" })}
                width="40px"
                height="40px"
                style={{ borderRadius: 4, objectFit: "contain" }}
              />
            ) : null}
            {!option.uuid ? (
              <Typography level="body-sm" textColor="neutral.600">
                {option.name}
              </Typography>
            ) : (
              option.name
            )}
          </AutocompleteOption>
        )}
      />
      {fieldState.error ? <FormHelperText>{fieldState.error.message}</FormHelperText> : null}
    </FormControl>
  );
}
